import { useHistory } from "react-router-dom";


const PurchaseFlowHeader = (props: { header: string }) => {
    const history = useHistory();
    const goBackHandle = () => {
        history.goBack();
    }

  return (
      <div className="purchase-container__title mb-6">
          <span className="purchase-container__back" onClick={goBackHandle}>
              <img alt="" src="/assets/icons/arrow-left.svg" />
          </span>
          <h3>{ props.header }</h3>
      </div>
  );
};

export default PurchaseFlowHeader;
